import * as sterlingparker from './DuotoneSgmLogo.styles.sterlingparker';
import * as betprofessor from './DuotoneSgmLogo.styles.betprofessor';
import * as volcanobet from './DuotoneSgmLogo.styles.volcanobet';
import * as puntgenie from './DuotoneSgmLogo.styles.puntgenie';
import * as junglebet from './DuotoneSgmLogo.styles.junglebet';
import * as fiestabet from './DuotoneSgmLogo.styles.fiestabet';
import * as puntcity from './DuotoneSgmLogo.styles.puntcity';
import * as betgalaxy from './DuotoneSgmLogo.styles.betgalaxy';
import * as betroyale from './DuotoneSgmLogo.styles.betroyale';
import * as juicybet from './DuotoneSgmLogo.styles.juicybet';
import * as goldenrush from './DuotoneSgmLogo.styles.goldenrush';
import * as vikingbet from './DuotoneSgmLogo.styles.vikingbet';
import * as questbet from './DuotoneSgmLogo.styles.questbet';
import * as wellbet from './DuotoneSgmLogo.styles.wellbet';
import * as sugarcastle from './DuotoneSgmLogo.styles.sugarcastle';
import * as oldgill from './DuotoneSgmLogo.styles.oldgill';
import * as buffalobet from './DuotoneSgmLogo.styles.buffalobet';
import * as titanbet from './DuotoneSgmLogo.styles.titanbet';
import * as gigabet from './DuotoneSgmLogo.styles.gigabet';
import * as slambet from './DuotoneSgmLogo.styles.slambet';
import * as betstride from './DuotoneSgmLogo.styles.betstride';
import * as templebet from './DuotoneSgmLogo.styles.templebet';
import * as goldenbet888 from './DuotoneSgmLogo.styles.goldenbet888';
import * as hyperbet from './DuotoneSgmLogo.styles.hyperbet';
import * as chromabet from './DuotoneSgmLogo.styles.chromabet';
import * as bet777 from './DuotoneSgmLogo.styles.bet777';
import * as bet575 from './DuotoneSgmLogo.styles.bet575';
import * as betblast from './DuotoneSgmLogo.styles.betblast';
import * as pyramidbet from './DuotoneSgmLogo.styles.pyramidbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  sterlingparker,
  betprofessor,
  volcanobet,
  puntgenie,
  junglebet,
  fiestabet,
  puntcity,
  betgalaxy,
  betroyale,
  juicybet,
  goldenrush,
  vikingbet,
  questbet,
  wellbet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  chromabet,
  bet777,
  bet575,
  betblast,
  pyramidbet,
};
